import { Box, Paper, Tab, Tabs } from '@mui/material';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { COLORS } from 'services/constants/colors';
import { REFERRALS_TABS } from './constants';

/** Tab bar of the Referrals section, styled like the one of Resources / Reference Tables. */
export const ReferralsTabs: FC = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const value = REFERRALS_TABS.some((tab) => tab.value === pathname) ? pathname : false;

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		navigate(newValue);
	};

	return (
		<Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
			<Paper
				sx={{
					m: '-12px -10px 10px -10px',
					borderRadius: '0!important',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', p: '4px 8px' }}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="referrals tabs"
						sx={{
							minHeight: '20px',
							'& .MuiTabs-indicator': {
								backgroundColor: 'primary.main',
								height: '0',
							},
							'& .MuiButtonBase-root': {
								fontWeight: 'bold',
								color: COLORS.PRIMARY,
								opacity: 1,
							},
							'& .Mui-selected': {
								color: COLORS.PRIMARY,
								opacity: 0.5,
							},
						}}
					>
						{REFERRALS_TABS.map((tab) => (
							<Tab
								key={tab.value}
								value={tab.value}
								label={tab.label}
								sx={{ fontWeight: 'bold', p: '0 10px', minHeight: '20px' }}
							/>
						))}
					</Tabs>
				</Box>
			</Paper>
		</Box>
	);
};
